export default "<textarea id=\"{{elementId}}\" #editorBody></textarea>";